import { queryOptions } from '@tanstack/react-query';
import { api } from '@/api/api';

export const holidayKeys = {
  all: ['holidays'] as const,
  byProject: (projectId: string) => [...holidayKeys.all, projectId] as const,
};

export const holidaysOptions = (projectId: string) =>
  queryOptions({
    queryKey: holidayKeys.byProject(projectId),
    queryFn: () => api.listHolidays(projectId),
    staleTime: 60_000,
  });
